import { Component, Inject, Input, OnInit } from "@angular/core";
import { FileUpDownloadController } from "@shared/src/controllers/fileupdownload/fileupdownload.controller";
import { PackageDataController } from "@shared/src/controllers/route/shipment/package.data.controller";
import { SecurityController } from "@shared/src/controllers/security/security.controller";
import { PackageDataDetailsDto } from "@shared/src/dtos/shipment/packagedata/PackageDataDetailsDto";
import { TenantCredentialProvider } from "@shared/src/enums/TenantCredentialProvider";
import { ShipmentController } from "@shared/src/public-api";

@Component({
    selector: "shared-package-data-component",
    templateUrl: "./shared.package.data.component.html",
    styleUrls: ["./shared.package.data.component.scss"],
})
export class SharedPackageDataComponent implements OnInit {
    constructor(
        public shipmentController: ShipmentController,
        public packageDataController: PackageDataController,
        @Inject("SecurityController")
        public securityController: SecurityController
    ) { }

    ngOnInit(): void { }

    @Input()
    public provider: TenantCredentialProvider;

    public data: PackageDataDetailsDto;

    private _packageId: number;
    public get packageId(): number {
        return this._packageId;
    }
    @Input() public set packageId(value: number) {
        this._packageId = value;
        if (this._packageId != null) {
            this.packageDataController.getPackageDetails(this._packageId, this.provider).subscribe(x => {
                this.data = x;
            });
        }
    }

    private _shipmentId: number;
    public get shipmentId(): number {
        return this._shipmentId;
    }
    @Input() public set shipmentId(value: number) {
        this._shipmentId = value;
        if (this._shipmentId != null) {
            this.packageDataController.getPackageDetailsByShipment(this._shipmentId, this.provider).subscribe(x => {
                this.data = x;
            });
        }
    }

    getLabel() {
        if (this.data && this.data.hasLabel) {
            this.packageDataController.downloadLabel(this.data.packageDataId, this.provider).subscribe(e => {
                if (e)
                    FileUpDownloadController.resultDownLoad(e);
            });
        }
    }

    public askingCreateLabel: boolean = false;

    createLabel() {
        if (this.data && !this.data.hasLabel) {
            this.askingCreateLabel = false;
            if (this.data.packageId) {
                this.packageDataController.createLabel(this.data.packageId, this.provider).subscribe(e => {
                    if (e)
                        this.data = e;
                });
            } else if (this.data.shipmentId) {
                this.packageDataController.createLabelByShipment(this.data.shipmentId, this.provider).subscribe(e => {
                    if (e)
                        this.data = e;
                });
            }
        }
    }

    getResourceBooking(){
        if(this.provider == TenantCredentialProvider.Dachser)
            return 'DACHSERCOMPONENT.BOOKING_ID.CAPTION';

        return 'ESCHENKERCOMPONENT.BOOKING_ID.CAPTION';
    }

    getResourceCreateLabelConfirm(){
        if(this.provider == TenantCredentialProvider.Dachser)
            return 'DACHSERCOMPONENT.CREATELABEL.CONFIRM';

        return 'ESCHENKERCOMPONENT.CREATELABEL.CONFIRM';
    }

    getResourceNoLabel(){
        if(this.provider == TenantCredentialProvider.Dachser)
            return 'DACHSERCOMPONENT.NOLABEL.CAPTION';

        return 'ESCHENKERCOMPONENT.NOLABEL.CAPTION';
    }

    pretty(item: any): string {
        return JSON.stringify(item);
    }

}
